import { map, isObject, isFunction } from 'lodash'
import dayjs from '@/node_modules/dayjs'

export enum LogLevel {
  DEBUG = 1,
  INFO,
  WARN,
  ERROR
}

export class Logger {
  private readonly level: LogLevel

  constructor(level: LogLevel = LogLevel.INFO) {
    this.level = level
  }

  private static createMessage(level: string, messages: any): string {
    const timestamp = dayjs().format('YYYY-MM-DD HH:mm:ss')
    const formattedMessages = map(messages, (item: any) => {
      if (item === undefined) return 'undefined'
      if (item === null) return 'null'
      if (isFunction(item)) return 'function'
      if (isObject(item)) {
        return '\n' + JSON.stringify(item, null, 2) + '\n'
      }

      return item
    })

    return `[${timestamp}] ${level}.${process.env.APP_ENV}: ${
      formattedMessages.length === 1
        ? formattedMessages[0]
        : formattedMessages.join(' ').trim()
    }`
  }

  debug(...messages: any[]): void {
    if (this.level > LogLevel.DEBUG) return
    console.log(Logger.createMessage('DEBUG', messages))
  }

  info(...messages: any[]): void {
    if (this.level > LogLevel.INFO) return
    console.log(Logger.createMessage('INFO', messages))
  }

  warn(...messages: any[]): void {
    if (this.level > LogLevel.WARN) return
    console.warn(Logger.createMessage('WARNING', messages))
  }

  error(...messages: any[]): void {
    console.error(Logger.createMessage('ERROR', messages))
  }
}

export function createLogger(): Logger {
  let level
  switch (process.env.LOG_LEVEL) {
    case 'debug':
      level = LogLevel.DEBUG
      break
    case 'info':
      level = LogLevel.INFO
      break
    case 'warn':
      level = LogLevel.WARN
      break
    case 'error':
      level = LogLevel.ERROR
      break
    default:
      level = LogLevel.INFO
  }
  return new Logger(level)
}

export default createLogger()
